<template>
  <v-dialog width="350px" persistent v-model="editDialog" class="editDialogsRow">
    <v-card-text class="pa-0" slot="activator">
      Add Location
      <v-icon class="text-xs-right">add</v-icon>
    </v-card-text>
    <v-card>
      <v-container>
        <v-layout justify-end row wrap>
          <v-flex xs1 class="mb-2">
            <v-icon depressed class="cyan--text text--lighten-1" @click="editDialog = false">close</v-icon>
          </v-flex>
          <v-flex xs12 class="mb-2">
            <v-card-title class="text-xs-center justify-center"><h2>Edit {{ trial.trialName }} Locations</h2></v-card-title>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
          <v-flex xs12 v-for="item in editedLocations" v-bind:key="item.objectName">
            {{item.name}}
          </v-flex>
          <v-flex xs12 class="text-xs-center">
            <v-card-text>
              <h3>Current Locations:</h3>
              <div v-for="item in locationsGetter" v-bind:key="item.locationID">
                {{ item.locationName }}
              </div>
            <!--<v-select
              :items="editedLocations"
              v-model="holder"
              item-value="name"
              label="Location"
              multiple-line
              bottom
              multiple
            ></v-select> -->
            <v-select
                name="trial.trialLocations"
                label="Add Trial Locations"
                :items="locations"
                item-value="locationId"
                item-text="locationName"
                v-model="editedLocations"
                id="trial.trialLocations"
                multiple
                max-height="400"
                hint="Pick your locations"
                persistent-hint
              ></v-select>             
            </v-card-text>
            <v-btn depressed class="grey white--text" to="/location/new">Create New Location</v-btn>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card-actions class="justify-center">
              <v-btn depressed class="grey lighten-1 white--text" @click="editDialog = false">Cancel</v-btn>
              <v-btn depressed class="white--text cyan " @click="onSaveChanges">Save</v-btn>
            </v-card-actions>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['trial'],
  data () {
    return {
      editDialog: false,
      editedLocations: this.trial.trialLocations,
      trialLocations: [],
      holder: []
    }
  },
  computed: {
    locations () {
      return this.$store.getters.loadedLocations
    },
    loadLocations () {
      return this.$store.getters.loadedTrials
    },
    locationsGetter () {
      if (this.trial.trialLocations) {
        var indis = []
        var val = []
        // var item = []
        this.trial.trialLocations.filter(function (elem) {
          indis.push(elem)
        })
        console.log('Location IDs: ' + JSON.stringify(indis))
        for (let i = 0; i < indis.length; i++) {
          console.log('SECOND GET Location: ' + JSON.stringify(this.$store.getters.loadedLocation(indis[i])))
          if (this.$store.getters.loadedLocation(indis[i])) {
            val.push(this.$store.getters.loadedLocation(indis[i]))
          }
        }
        console.log('FINAL val: ' + JSON.stringify(val))
        return val
      } else {
        return null
      }
    }
  },
  methods: {
    onSaveChanges () {
      this.trialLocations = this.editedLocations
      this.editDialog = false
      console.log('edit page: ' + this.trialLocations)
      this.$store.dispatch('updateTrialData', {
        trialId: this.trial.trialId,
        trialLocations: this.trialLocations
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// EditTrialLocationsDialog.vue?a13e134a